import { defineRouter } from "#q-app";
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import routes from "./routes";

import { useSettingsStore } from "@/store/settingsStore";

import { error } from "@/utils/notifications";
import { ping, getAvatarUrl } from "@/utils/api";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = import.meta.env.QUASAR_SERVER
    ? createMemoryHistory
    : import.meta.env.QUASAR_VUE_ROUTER_MODE === "history"
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.config.js instead!
    // quasar.config.js -> build -> vueRouterMode
    // quasar.config.js -> build -> publicPath
    history: createHistory(import.meta.env.QUASAR_VUE_ROUTER_BASE),
  });

  Router.beforeEach(async (to, from) => {
    const settingsStore = useSettingsStore();

    if (settingsStore.userLoggedIn) {
      let result;
      try {
        result = await ping();
        if (result.status !== undefined && result.status == 200) {
          settingsStore.user.data = result.data;
          settingsStore.updateAvatarUrl(getAvatarUrl(result.data.avatar));
        } else {
          settingsStore.logOut();
        }
      } catch (err) {
        if (err === undefined) {
          // No connection to internet
          error("Connection lost...");
          console.warn("Connection lost");
        } else {
          console.error("Error sending ping. Logout!", err);
          settingsStore.logOut();
        }
      }
    }
    //console.log(from, to);
    if (to.meta.requiresAuth && !settingsStore.userLoggedIn) {
      return "/pilot/login?redirect=" + to.fullPath;
    } else if (to.meta.requiresNoAuth && settingsStore.userLoggedIn) {
      return "/";
    } else {
      return;
    }
  });

  return Router;
});
